import { Component } from '@angular/core';

@Component({
  selector: 'app-amadeus',
  templateUrl: './amadeus.component.html',
  styleUrls: ['./amadeus.component.css']
})
export class AmadeusComponent {



  checked = false;
  indeterminate = false;
  labelPosition: 'before' | 'after' = 'after';
  disabled = false;
}
